import PropTypes from 'prop-types';
import addressShape from 'react/signups/card/shapes/AddressShape';

const businessDataShape = PropTypes.shape({
  name: PropTypes.string,
  address: addressShape,
  numberOfClients: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  numberOfInitialCards: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

export default businessDataShape;
